<template>
  <div class="plugin-wrapper swiper__wrapper" v-if="config && Array.isArray(config.nodes) && config.nodes.length">
    <swiper class="swiper-x-container" :ref="'xSwiper' + _uid" :options="swiperOpts">
      <swiper-slide class="swiper-x-item" v-for="(item, index) in config.nodes" :key="index">
        <template v-if="item.tag == 'image'">
          <!-- <img :src="item.src.pc" class="show-for-md" @click="actionHandler(config.action)" alt />
          <img :src="item.src.h5" class="hide-for-md" @click="actionHandler(config.action)" alt /> -->
          <picture>
            <source media="(min-width: 1024px)" :srcset="item.src.pc + '?x-oss-process=image/resize,w_1200/quality,q_95'">
            <source media="(min-width: 0)" :srcset="item.src.h5 + '?x-oss-process=image/resize,w_750/quality,q_95'">
            <img class="image__fit" :src="item.src.pc + '?x-oss-process=image/resize,w_1200/quality,q_95'" @click="actionHandler(config.action)" alt />
          </picture>
        </template>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import acitonMixins from "@/utils/action.mixins";

export default {
  name: 'BaseSwiper',
  mixins: [acitonMixins],
  components: { swiper, swiperSlide },
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      xSwiper: {},
      swiperOpts: {
        loop: true,
        loopedSlides: this.config.nodes.length + 2,
        speed: 1000,
        slidesPerView: 1
      }
    }
  },
  mounted() {
    this.xSwiper = this.$refs?.[`xSwiper` + this._uid]?.swiper;
  }
}
</script>

<style>
  .swiper {
    box-sizing: border-box; width: 100%; height: auto;
  }
</style>